module.exports = __webpack_public_path__ + "media/images/minus-12cb0ed5dd067bb23013124c0a76925e.svg";